import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../Button";
import PriceFormatted from "../Application/PriceFormatted";
import apiPlatform from "../../apiPlatform";
import getWorkshopCurrentPlanSettings from "../../utils/getWorkshopCurrentPlanSettings";
import moment from "moment";
import isPricingDetailsHidden from "../../utils/isPricingDetailsHidden";
import {useTranslation} from "react-i18next";
import AppSelect from "../../componentsReusable/AppSelect";
import {TCD_VEHICLE_TYPE_CAR, TCD_VEHICLE_TYPE_TRUCK} from "./TecRmiVehicleTypeSuppliers";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import getWorkshop from "../../utils/getWorkshop";
import {useSelector} from "react-redux";
import {sendIntercomMessage} from "../../utils/intercom";

const TEC_RMI_PRICING = {
  [TCD_VEHICLE_TYPE_CAR]: {
    '3m': 620,
    '12m': 1900,
  },
  [TCD_VEHICLE_TYPE_TRUCK]: {
    '3m': 740,
    '12m': 2300,
  },
}

const TecRmiBuyAccessModal = props => {
  const { t } = useTranslation('tec_rmi_buy_access_modal');
  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = React.useState({
    showType: props.showType ?? TCD_VEHICLE_TYPE_CAR,
    period: '12m',
  })
  const user = useSelector(state => state.user)

  useAfterUpdateEffect(() => {
    setData({
      ...data,
      showType: props.showType ?? TCD_VEHICLE_TYPE_CAR,
    })
  }, [props.showType])

  if(isPricingDetailsHidden()){
    return null
  }

  const showTypeOptions = [
    {
      name: 'Osobowe i dostawcze',
      id: TCD_VEHICLE_TYPE_CAR,
    },
    {
      name: 'Ciężarowe',
      id: TCD_VEHICLE_TYPE_TRUCK,
    },
  ]

  const periodOptions = [
    {
      name: '12 miesięcy',
      id: '12m',
    },
    {
      name: '3 miesiące',
      id: '3m',
    },
  ]

  const getTecRmiType = () => {
    if(data.showType === TCD_VEHICLE_TYPE_CAR){
      return getWorkshopCurrentPlanSettings('tecRmiTypeCar')
    }else if(data.showType === TCD_VEHICLE_TYPE_TRUCK){
      return getWorkshopCurrentPlanSettings('tecRmiTypeTruck')
    }
  }

  const submit = () => {
    setLoading(true)

    apiPlatform.workshopPlanTransaction.tecRmiAccess({
      showType: data.showType,
      period: data.period,
    })
      .then(res => {
        window.location.href = res.data.redirectUri
      })
      .finally(() => setLoading(false))
  }

  const sendMessageToIntercom = () => {
    const message = t('intercom_demo_access_request_message', {
      type: t(`intercom_demo_access_request_message_type_${props.showType}`),
      email: user.email || t('intercom_demo_access_request_fill'),
      nip: ((getWorkshop()?.workshopDetails?.nip && !['1234567890'].includes(getWorkshop().workshopDetails.nip)) ? getWorkshop().workshopDetails.nip : t('intercom_demo_access_request_fill')),
      phone: user.phoneNumber.number || t('intercom_demo_access_request_fill'),
    });

    sendIntercomMessage(message);
  }

  return <React.Fragment>
    <div className="d-flex justify-content-center justify-content-center">
    {React.cloneElement(props.btn ?? <Button color={'success'}>
      <i className="fas fa-shopping-cart"/>
      <span>{t('btn_text')}</span>
    </Button>, {
      onClick: () => setModalOpen(true),
    })}
      {props.showDemoRequestButton && <Button className="ml-2" onClick={sendMessageToIntercom}><i className="fas fa-question-circle"/><span>{t('btn_demo_access_request_text')}</span></Button>}
    </div>
    {modalOpen && <Modal isOpen size="md">
      <ModalHeader>{t('header')}</ModalHeader>
      <ModalBody>
        <FormGroup row>
          <Label className="text-right" xs={6}>{t('show_type')}:</Label>
          <Col xs={6}>
            <AppSelect
              className="w-100"
              isClearable={false}
              value={showTypeOptions.find(option => option.id === data.showType)}
              options={showTypeOptions}
              onChange={option => setData({...data, showType: option.id})}
            />
          </Col>
        </FormGroup>
        {
          getTecRmiType().isActive
            ? <Alert color={'success'}>
              <i className="fas fa-check-circle text-success mr-2" />
              <span>{t('access_active', {date: moment(getTecRmiType().accessExpireAt).format('YYYY-MM-DD')})}</span>
            </Alert>
            : <>
              <FormGroup row>
                <Label className="text-right" xs={6}>{t('time_period')}:</Label>
                <Col xs={6}>
                  <AppSelect
                    className="w-100"
                    isClearable={false}
                    value={periodOptions.find(option => option.id === data.period)}
                    options={periodOptions}
                    onChange={option => setData({...data, period: option.id})}
                  />
                </Col>
              </FormGroup>
              <FormGroup className="font-weight-bold" row>
                <Label className="text-right" xs={6}>{t('price')}:</Label>
                <Label xs={6}><PriceFormatted value={TEC_RMI_PRICING[data.showType][data.period]} decimalScale={2} /> PLN</Label>
              </FormGroup>
            </>
        }
      </ModalBody>
      <ModalFooter>
        <Button color="light" className="mr-auto" onClick={() => setModalOpen(false)}>{t('common:btn.close')}</Button>
        <Button
          color={'success'}
          loading={loading}
          onClick={submit}
          disabled={getTecRmiType().isActive}
        >
          <i className="fas fa-shopping-cart" />
          <span>{t('go_to_payment')}</span>
        </Button>
      </ModalFooter>
    </Modal>}
  </React.Fragment>;
};

TecRmiBuyAccessModal.defaultProps = {
  showDemoRequestButton: false
}

TecRmiBuyAccessModal.propTypes = {
  btn: PropTypes.object,
  showType: PropTypes.string,
  showDemoRequestButton: PropTypes.bool
};

export default TecRmiBuyAccessModal;